import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';

function Newsedit() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [news, setNews] = useState([]);
  const [date, setDate] = useState("");
  let { id } = useParams();
  const [formerror, setError] = useState({});

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/news/get-news/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200) {
      const data = await res.json();

      setNews(data.data);
      setDate(moment(data.data.publishDate).utc().format("YYYY-MM-DD"));

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  // const sdf = SimpleDateFormat("yyyy-MM-dd")
  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;

    setNews({ ...news, [name]: value });
  };
  const handleInput = (e) => {
    console.log(e);
    value = e.target.value;

    setDate(value);
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setNews({ ...news, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = "Title is required!";
    }

    if (!values.description) {
      errors.description = "Description is required!";
    }

    if (!values.author) {
      errors.author = "Author is required!";
    }
    if (!values.newsImg) {
      errors.newsImg = "Image is required!";
    } else if (values.newsImg.type) {
      if (
        values.newsImg.type === "image/jpeg" ||
        values.newsImg.type === "image/jpg" ||
        values.newsImg.type === "image/png"
      ) {
        if (values.newsImg.size > 1024 * 1000) {
          errors.newsImg =
            "maximum file size 1 mb...please upload an image less than 1 mb";
        }
      } else {
        errors.newsImg = "Only support jpg, jpeg, png image!";
      }
    }

    return errors;
  };
  const PostData = async (e) => {
    e.preventDefault();
    const { title, description, newsImg, publishDate, author } = news;
    const ress = validate(news);
    setError(ress);
    if (
      !ress.title &&
      !ress.description &&
      !ress.newsImg &&
      !ress.publishDate &&
      !ress.author
    ) {
      const formData = new FormData();
      formData.append("title", news.title);
      formData.append("description", news.description);
      formData.append("author", news.author);
      formData.append("publishDate", date);
      formData.append("newsImg", news.newsImg);
      formData.append("status", news.status);

      axios
        .put(`${Config.apiurl}/api/v1/crm/news/update/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {

            toast.success("Sucessfully Updated", {
              position: "top-center",
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);

          
          }
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            toast.error("Something went wrong", {
              position: "top-center",
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };
  useEffect(() => {
    getinfo();
  }, []);
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row grid-margin">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">News Data Table</h4>
                    <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1"> Title</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Title"
                          name="title"
                          value={news.title}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.title}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Description"
                          name="description"
                          value={news.description}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.description}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Created By
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder=" Created By"
                          name="author"
                          value={news.author}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.author}
                        </label>
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Date</label>
                        <input
                          type="date"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Date"
                          name="publishDate"
                          value={date}
                          //value="2023-01-01"
                          onChange={handleInput}
                          onClick={(e) => e.target.showPicker()}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Image (400px * 340px)
                        </label>
                        <br></br>
                        <input
                          type="file"
                          name="newsImg"
                          onChange={onFileChange}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.newsImg}
                        </label>
                        <img src={news.newsImage} width="200" alt="" />
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Status</label>

                          <select
                            className="form-control "
                            style={{
                              color: "black",
                              backgroundColor: "#2b2e4c;",
                            }}
                            id="exampleInputUsername1"
                            name="status"
                            onChange={handleInputs}
                            value={news.status}
                          >
                            <option
                              {...(news.status === "1" ? "selected" : "")}
                            >
                              true
                            </option>
                            <option
                              {...(news.status === "0" ? "selected" : "")}
                            >
                              false
                            </option>
                          </select>
                        </div>
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Newsedit;
